import { Cookies } from 'react-cookie';

import { CreateVisitReportFormValues } from '../type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface CreateVisitReportInterface {
  createVisitReportData: CreateVisitReportFormValues;
  slug: string;
}

export const createVisitReport = async ({ createVisitReportData, slug }: CreateVisitReportInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.post(
    `/create-visit-report-document/${slug}/`,
    {
      ...createVisitReportData,
    },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
